import { Link } from 'gatorcomponents';
import React from 'react';

export default {
  manualSelectDns: {
    backLabel: 'Voltar',
    cancelLabel: 'Cancelar',
    continueLabel: 'Continuar',
    nextStepLabel: 'Próximo passo',
    finishLabel: 'Ok, entendi',
    howToSetupLabel: 'Ver como configurar',
    backToInstructions: 'Voltar para instruções',
    helpLink: (
      <>
        {'Está com dificuldade? '}
        <Link
          href="https://suporte.hostgator.com.br/hc/pt-br/articles/30811169438099-Como-configurar-o-dom%C3%ADnio-alterar-DNS-em-outro-provedor-Registro-br-UOL-Host-GoDaddy-Locaweb-KingHost"
          target="_blank"
          text="Acesse a Central de Ajuda"
        />
      </>
    ),
    titleV2: 'Como configurar domínio no outro provedor de site',
    close: 'Fechar',
    step: {
      disclaimerExternalDomain: {
        title: 'Seu domínio não está registrado na HostGator. Para ativar a CDN, é necessário ajustar o apontamento para a Cloudflare',
        subtitle: ({ domain }) => `Siga as instruções na próxima tela para configurar corretamente o domínio "${domain}".`,
        cta: 'Iniciar configuração',
      },
      checkStatus: {
        title: 'Verificar Domínio',
        subtitle: 'Verifique o status de configuração do seu domínio.',
        description: 'Estamos conferindo se está tudo pronto para ativar sua CDN...',
        whereDomainIsConfiguredLabel: 'Onde o domínio foi registrado?',
        selectHostPlaceholder: 'Selecionar provedor',
      },
      domainOriginalRegistration: {
        title: 'Verificar domínio',
        subtitle: 'Verifique o status de configuração do seu domínio.',
        alertDescription: domain => (
          <>
            {'Como o domínio '}
            <span>
              {`"${domain}" `}
            </span>
            não foi registrado na HostGator, você precisa acessar o site onde ele foi registrado e mudar as configurações para apontar para a sua hospedagem na HostGator.
          </>
        ),
        inputLabel: 'Selecione onde ele foi registrado',
        selectPlaceholder: 'Selecionar',
      },
      domainOriginalRegistrationV2: {
        subtitle: 'Selecione o provedor onde o domínio foi registrado',
        selectPlaceholder: 'Selecionar',
        disabledNextStepToolTip: 'Clique no botão do provedor para prosseguir',
      },
      howToSetup: {
        title: 'Como configurar domínio no outro provedor de site ',
        howToSectionTitle: 'Siga o passo a passo para substituir seu nome de servidor',
        steps: ({ from }) => [
          {
            id: 'firstStep',
            description: 'Acesse o site do provedor onde seu domínio está registrado',
          },
          {
            id: 'secondStep',
            description: `Localize os nomes de servidores (DNS) atuais no site da ${from}`,
          },
          {
            id: 'thirdStep',
            description: `Substitua o nomes de servidores (DNS) que está no site da ${from} pelo da CloudFlare. Basta copiar e colar os valores abaixo:`,
            alert: 'Ao continuar suas configurações atuais do domínio serão alteradas',
          },
        ],
        serverLabel: index => `Servidor ${index + 1} (DNS): `,
        goTo: selectedManualDns => `ir para ${selectedManualDns}`,
        alreadyMadeChanges: 'Continuar',
        backtoInstructions: 'Voltar',
      },
      howToSetupV2: {
        subtitle: 'Substitua os nomes de servidores atuais (DNS) pelos novos nomes de servidores abaixo. Copie os valores, cole no site do seu provedor atual e salve as alterações.',
        alert: 'Ao continuar suas configurações atuais do domínio serão alteradas para os da Cloudflare.',
        serverLabel: index => `Servidor ${index + 1}: `,
        alreadyMadeChanges: 'Já fiz a configuração',
        originalDnsLabel: 'Nomes de servidores atuais (DNS)',
        newDnsLabel: 'Seu novo nome de servidor (DNS)',
        configureDomainText: 'Ao clicar em “configurar domínio” você será redirecionado para o site do seu provedor para realizar o passo 2. Essa ação é necessária para que o seu domínio possa usar a CDN.',
        configureDomainButton: 'Configurar domínio',
        domainHasConfiguredLabel: 'Já fiz a configuração do meu domínio para o da Cloudflare.',
        backtoInstructions: 'Voltar',
      },
      finishDomainSetup: {
        title: 'Finalizando as configurações de domínio',
        subtitle: 'Após ter realizado as configurações, acompanhe aqui o status de seu domínio.',
        box: {
          title: 'Alterações que você realizou:',
          description: ({ from }) => `DNS atual na ${from} para DNS da Hostgator`,
          alert: (
            <>
              <strong>
                {'Em andamento: '}
              </strong>
              {'A configuração do domínio ainda está acontecendo e pode levar até '}
              <strong>24 horas.</strong>
            </>
          ),
        },
      },
      finishDomainSetupV2: {
        title: 'Finalizando as configurações de domínio',
        subtitle: 'Acompanhe aqui o status do seu domínio.',
        box: {
          title: 'Alterações que você realizou:',
          description: ({ from }) => `Transferência ${from ? `DNS ${from} para DNS Cloudflare.` : ' para DNS da Cloudflare.'}`,
          alert: (
            <>
              <strong>
                {'Em andamento: '}
              </strong>
              {'A configuração do domínio ainda está acontecendo e pode levar até '}
              <strong>24h</strong>
              {' para domínios nacionais e até '}
              <strong>72h</strong>
              {' para domínios internacionais.'}
            </>
          ),
        },
      },
      domainNotRegistered: {
        title: domain => `O domínio “${domain}” ainda não está registrado`,
        description: 'Para criar um novo site o domínio precisa estar registrado e ativo. Clique no botão para registrá-lo agora mesmo!',
        redirectLabel: 'Registrar domínio',
      },
      activationError: {
        domainWithProblemTitle: 'Domínio temporariamente indisponível',
        domainWithProblemDescription: 'Não foi possível ativar a CDN por conta de problemas no seu domínio, por favor, entre em contato com o seu registrante e confirme se há alguma pendência.',
        confirmationCta: 'Ok, entendi',
      },
    },
  },
};
